import React, { Component } from 'react';

class Avatar extends Component {
  // TODO: Load bee on mount

  constructor(props) {
    super(props);

    this.state = {};
  }

  componentDidMount() {
    const self = this;

    this.props.beeReference.get().then(bee => 
      self.setState(Object.assign({}, self.state, {
          bee: bee.data()
      }))
    );
  }

  render() {
  	let content;

  	if (this.state.bee) {
      console.log("bee", this.state.bee);

  		content = (
	  		<div className="App-wanna-bee-frame">
          <img className="App-wanna-bee" src={this.state.bee.avatar}/>
        </div>
	  	);
  	} else {
  		content = (
	  		<div className="App-wanna-bee">...</div>
	  	);
  	}

    return content;
  }
}

export default Avatar;


// WEBPACK FOOTER //
// ./src/Avatar.js